export default __webpack_public_path__ + "static/never-e70e881c6e05aab05ed00863f45206ed.png";